export default function MaskIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="26"
      viewBox="0 0 22 26"
      fill="none"
    >
      <path
        d="M3.25417 17.9667C3.52917 18.8875 4.2625 19.5917 5.13334 19.5917H16.8208C17.6917 19.5917 18.425 18.9417 18.7 17.9667C20.5333 17.2625 21.725 15.6375 21.725 13.7958C21.725 11.9542 20.5333 10.3292 18.7 9.625C18.425 8.70417 17.6917 8 16.8208 8H5.17917C4.30834 8 3.575 8.65 3.3 9.625C1.42084 10.3292 0.275004 11.9542 0.275004 13.7958C0.229171 15.6375 1.42084 17.2625 3.25417 17.9667ZM20.8542 13.7958C20.8542 14.9875 20.075 16.125 18.8375 16.775V10.8167C20.075 11.4667 20.8542 12.6042 20.8542 13.7958ZM4.07917 10.3833C4.07917 9.67917 4.58334 9.08333 5.17917 9.08333H16.8667C17.3708 9.08333 17.8292 9.51667 17.9208 10.1667V17.425C17.8292 18.0208 17.3708 18.4542 16.8667 18.4542H5.17917C4.58334 18.4542 4.07917 17.8583 4.07917 17.1542V10.3833ZM3.1625 10.8167V16.7208C1.925 16.0708 1.14584 14.9875 1.14584 13.7417C1.14584 12.6042 1.925 11.4667 3.1625 10.8167Z"
        fill="#959595"
      />
      <path
        d="M6.37083 11.575H15.675V12.6583H6.37083V11.575ZM6.37083 14.6625H15.675V15.7458H6.37083V14.6625Z"
        fill="#959595"
      />
    </svg>
  );
}
